<div class="renew-wrapper" *ngIf="checkout()?.renewable && !checkout()?.renewed">
  <button class="accent transparent" mat-flat-button [class.waiting]="waiting" appStopPropagation (click)="doRenew()">
    <ng-container *ngIf="!waiting"> {{ 'button.renew' | translate }} </ng-container>

    <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
  </button>
</div>
